import { useEffect, useState } from 'react';

export const getReason = (status) => {
    const reasons = status?.slice()?.reverse()?.find((s, i) => s?.status === "CANCELLED_BY_STUDENT" || s?.status === "REJECTED_BY_COUNSELOR" || s?.status === "RESCHEDULED_BY_STUDENT" || s?.status === "RESCHEDULED_BY_COUNSELOR")
    // const reasons = status?.slice()?.reverse()?.find((s, i) => s?.status === activeTab)
    return reasons ? reasons?.extra?.reason : null
}

export const getNotes = (status) => {
    const reasons = status?.slice()?.reverse()?.find((s, i) => s?.status === "APPLIED")
    // const reasons = status?.slice()?.reverse()?.find((s, i) => s?.status === activeTab)
    return reasons ? reasons?.extra?.notes : null
}

export const getOnDateByStatus = (data, type) => {
    if (type === "acceptedOn") {
        const onDate = data.find((s) => s.status === "ACCEPTED_BY_COUNSELOR")?.onDate
        return onDate
    } else if (type === "completedAt") {
        const onDate = data.find((s) => s.status === "COMPLETED")?.onDate
        return onDate
    }
}

export const convertToTitleCase = (str) => {
    return str
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export const toSentenceCase = (str) => {
    const words = str
        .replaceAll('_', ' ')
        .replaceAll(/([a-z])([A-Z])/g, '$1 $2')
        .split(' ');

    return words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const addSpaces = (str) => {
    return str
        .replaceAll(/([a-z])([A-Z])/g, '$1 $2')
        .replaceAll('_', ' ');
};

export const getStatusComponent = (status, tab) => {
    const statusItem = tab?.find(
        (item) => item.value === status
    );

    if (!statusItem) return null;

    return (
        <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: statusItem.color }}>
            {statusItem.icon}
            <span>{statusItem.label}</span>
        </span>
    );
};

export const isWithinSessionWindow = (onDateTime) => {
    if (!onDateTime) return false;
    // Use current time plus the 5.5 hour IST offset to match 
    // how the backend timestamps are being handled/displayed.
    const nowUTC = new Date();
    const IST_OFFSET = 5.5 * 60 * 60 * 1000;
    const nowIST = new Date(nowUTC.getTime() + IST_OFFSET);
    const sessionTime = new Date(onDateTime);
    const diffInMin = (sessionTime - nowIST) / (1000 * 60);
    return diffInMin >= -120 && diffInMin <= 10;
};

export const getWebinarEndTime = (webinar) => {
    if (!webinar?.onDateTime) return null;

    const startTime = new Date(webinar.onDateTime).getTime();
    if (Number.isNaN(startTime)) return null;

    const duration = Number(webinar.meetingTime);
    const durationInMinutes = Number.isFinite(duration) && duration > 0 ? duration : 24 * 60;
    return startTime + durationInMinutes * 60 * 1000;
};

export const isWebinarCompleted = (webinar, now = Date.now()) => {
    if (webinar?.latestStatus === 'COMPLETED' || webinar?.status === 'COMPLETED') {
        return true;
    }

    const endTime = getWebinarEndTime(webinar);
    return endTime !== null && now >= endTime;
};

export const useWebinarNow = (webinars) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const items = Array.isArray(webinars) ? webinars : [webinars];
        const currentTime = Date.now();
        if (items.some((webinar) => {
            const endTime = getWebinarEndTime(webinar);
            return endTime !== null && endTime > now && endTime <= currentTime;
        })) {
            setNow(currentTime);
            return undefined;
        }

        const nextEndTime = items.reduce((next, webinar) => {
            const endTime = getWebinarEndTime(webinar);
            return endTime !== null && endTime > currentTime && endTime < next
                ? endTime
                : next;
        }, Infinity);

        if (nextEndTime === Infinity) return undefined;

        const timer = setTimeout(
            () => setNow(Date.now()),
            Math.min(nextEndTime - currentTime, 2147483647)
        );
        return () => clearTimeout(timer);
    }, [webinars, now]);

    return now;
};
